import {getElementChild, getElements} from '../Utility/Dom'

class LanguageSwitcher {
  private readonly buttons: NodeListOf<HTMLElement>

  constructor() {
    this.buttons = getElements('language-switcher-button')
  }

  public init(): void {
    if (this.buttons.length === null) return

    this.addEvents()
  }

  private addEvents(): void {
    this.buttons.forEach((button: HTMLButtonElement): void => {
      button.addEventListener('click', (): void => {
        button.setAttribute('aria-expanded', this.isButtonExpanded(button) ? 'false' : 'true')
      })
    })

    document.addEventListener('keydown', (event: KeyboardEvent): void => {
      this.buttons.forEach((button: HTMLButtonElement): void => {
        if (event.key === 'Escape' && this.isButtonExpanded(button)) {
          this.close(button)
        }
      })
    })

    document.addEventListener('click', (event: MouseEvent): void => {
      const target = event.target as HTMLElement

      this.buttons.forEach((button: HTMLButtonElement): void => {
        let list = button.parentElement

        if (list !== null) {
          list = getElementChild(list, 'language-switcher-button')
        }

        if (
          this.isButtonExpanded(button) &&
          target !== button &&
          list?.contains(target) === false
        ) {
          this.close(button)
        }
      })
    })
  }

  private close(button: HTMLButtonElement): void {
    button.setAttribute('aria-expanded', 'false')
    button.focus()
  }

  private isButtonExpanded(button: HTMLButtonElement): boolean {
    return button.getAttribute('aria-expanded') === 'true'
  }
}

const languageSwitcher = new LanguageSwitcher()
languageSwitcher.init()
